export default __webpack_public_path__ + "static/media/plus.dd0dcb7a.svg";